import styled from '@emotion/styled';

import { theme } from '../../theme/theme';

export function IndicatorNumberStatic({ device, capabilityId }) {
  const isMeasurePower = capabilityId.startsWith('measure_power');
  const unitsPostFix = device.capabilitiesObj[capabilityId]?.units
    ? ` ${device.capabilitiesObj[capabilityId].units}`
    : '';

  return (
    <IndicatorNumberStatic.Root data-style-color={isMeasurePower === true ? 'green' : undefined}>
      {unitsPostFix}
    </IndicatorNumberStatic.Root>
  );
}

IndicatorNumberStatic.Root = styled.div`
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.bold};
  text-align: end;

  &[data-style-color='green'] {
    color: #0ba95d;
  }
`;
